import { FixElementRuleIds, RuleId, ValidatedArray } from '../../values/index.js';
export const Props = (props = {}) => ({
    typographyIds: ValidatedArray(RuleId, props.typographyIds),
    decorationIds: ValidatedArray(RuleId, props.decorationIds),
    fillIds: ValidatedArray(RuleId, props.fillIds),
    graphicIds: ValidatedArray(RuleId, props.graphicIds),
    paletteIds: ValidatedArray(RuleId, props.paletteIds),
    spacingIds: ValidatedArray(RuleId, props.spacingIds)
});
export const fix = (props, styles) => ({
    typographyIds: FixElementRuleIds('typography', props.typographyIds, styles),
    decorationIds: FixElementRuleIds('decoration', props.decorationIds, styles),
    fillIds: FixElementRuleIds('fill', props.fillIds, styles),
    graphicIds: FixElementRuleIds('graphic', props.graphicIds, styles),
    paletteIds: FixElementRuleIds('palette', props.paletteIds, styles),
    spacingIds: FixElementRuleIds('spacing', props.spacingIds, styles)
});
export const validate = () => true;
export const type = 'inline';
export const label = 'Inline elements';
export const category = 'element';
export const aspects = ['typography', 'spacing', 'decoration', 'fill', 'palette'];
//# sourceMappingURL=inline.js.map